import { controls,grouped } from "../controls";
const bulk_user_requests = {
label: "Bulk User Requests",
pageLabel: "Bulk User Requests",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
bulk:{columns:["user_code","user_display","mobile","email","username","password","from_date","to_date","role"] },
formTabs:
 {allTabs: [
{ label: "General", uid: "general" },
{label:"Bulk",uid:"bulk"}
]},
filter:[
...controls.displayText({ tab: "filter", label: "User Code"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "user_code",maxlength:50}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Description"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "user_display",maxlength:50}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Username"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "username",maxlength:50}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Mobile"}),
...controls.floatOnly({ tab: "filter",  placeHolder: "", name: "mobile",maxlength:14}),
...controls.displayText({ tab: "filter",  label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "E-mail"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "email",width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "filter", label: "Role"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "role",width:"col-sm-4",maxlength:100}),
]
,form:[
...controls.displayText({ tab: "general", label: "Code",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "user_code",isRequired:true,maxlength:50 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Description",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "user_display",maxlength:50 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Mobile",star:false}),
...controls.mobileNumber({ tab: "general",  placeHolder: "", name: "mobile",maxlength:13}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "E-mail",star:false}),
...controls.Email({ tab: "general",  placeHolder: "", name: "email",maxlength:100}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Username",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "username",isRequired:true,maxlength:50 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Password",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "password",width:"col-sm-4",maxlength:200 ,isReadOnly:"edit" }),
...controls.magicDateLabel({ tab: "general", label: "From Date",target: "from_date",star:false}),
...controls.magicDate({ tab: "general", name: "from_date", dateType: "ontype" ,isReadOnly:"edit"  }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.magicDateLabel({ tab: "general", label: "To Date",target: "to_date",star:false}),
...controls.magicDate({ tab: "general", name: "to_date", dateType: "ontype" ,isReadOnly:"edit"  }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Role",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "role",width:"col-sm-4",maxlength:100 ,isReadOnly:"edit" }),
]
,history:{
perPage: 10,
reportHeader: "Bulk User Requests",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "User Code",accessor: "user_code",},
{Header: "User",accessor: "user_display",},
{Header: "Username",accessor: "username",},
{Header: "Mobile",accessor: "mobile",},
{Header: "E-mail",accessor: "email",},
{Header: "From Date",accessor: "from_date",type:'date'},
{Header: "To Date",accessor: "to_date",type:'date'},
{Header: "Role",accessor: "role",},
]}};
export default bulk_user_requests;